import * as React from 'react'
import { v4 as uuid4 } from 'uuid'

export interface ToastItem {
  id: string
  onCancel: () => void
  content: React.ReactNode
}

// TODO: could be configurable
const TOAST_DURATION = 5000

export const useToasts = () => {
  const [toasts, setToasts] = React.useState<ToastItem[]>([])

  const add = (toast: ToastItem) => setToasts((state) => [...state, toast])

  const remove = (id: string) =>
    setToasts((state) => state.filter((x) => x.id !== id))

  const show = (content: React.ReactNode) => {
    const id = uuid4()
    const removeTimer = setTimeout(() => remove(id), TOAST_DURATION)
    add({
      id,
      content,
      onCancel: () => {
        clearTimeout(removeTimer)
        remove(id)
      }
    })
  }

  return {
    show,
    toasts
  }
}

export type ToastsApi = ReturnType<typeof useToasts>
const ToastsCtx = React.createContext<ToastsApi | null>(null)

export const Toasts = {
  Provider: ToastsCtx.Provider,
  use: (): ToastsApi => {
    const ctx = React.useContext(ToastsCtx)
    if (ctx === null) {
      throw new Error('Must be wrapped within Toasts.Provider')
    }
    return ctx
  }
}
